import { configureStore } from "@reduxjs/toolkit";

// Import all slices
import authReducer from "./slices/auth/authSlice";
import usersReducer from "./slices/users/usersSlice";
import userProfileReducer from "./slices/userProfile/userProfileSlice";
import dailyUsageReducer from "./slices/dailyUsage/dailyUsageSlice";
import mealsReducer from "./slices/meals/mealsSlice";
import subscriptionsReducer from "./slices/subscriptions/subscriptionsSlice";
import mealRecipeCountsReducer from "./slices/mealRecipeCounts/mealRecipeCountsSlice";
import userPlanReducer from "./slices/userPlan/userPlanSlice";
import dietPreferencesReducer from "./slices/dietPreferences/dietPreferencesSlice";
import premiumAccessReducer from "./slices/premiumAccess/premiumAccessSlice";
import analyticsReducer from "./slices/analytics/analyticsSlice";
import workoutPlansReducer from "./slices/workoutPlans/workoutPlansSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    userProfile: userProfileReducer,
    dailyUsage: dailyUsageReducer,
    meals: mealsReducer,
    subscriptions: subscriptionsReducer,
    mealRecipeCounts: mealRecipeCountsReducer,
    userPlan: userPlanReducer,
    dietPreferences: dietPreferencesReducer,
    premiumAccess: premiumAccessReducer,
    analytics: analyticsReducer,
    workoutPlans: workoutPlansReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
  devTools: process.env.NODE_ENV !== "production",
});

// Type definitions for TypeScript users
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
